export default __webpack_public_path__ + "static/media/chevron_left.dfc10eed.svg";